import SwitchFake from "@/components/switch/switch-fake";
import styles from "../styles";

const SwitchCerberusFake = () => {
  return (
    <>
      <div className="cerberus__fake--box--switch">
        <div className="cerberus__fake--box--switch--info">
          <div className="skeleton cerberus__fake--box--switch--info--label" />
          <div className="skeleton cerberus__fake--box--switch--info--text" />
        </div>
        <SwitchFake />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default SwitchCerberusFake;
